// extracted by mini-css-extract-plugin
export default {"mainContainer":"PageLayout_mainContainer__lAMCF","banner":"PageLayout_banner__EFJ9C"};